import { render, staticRenderFns } from "./LicenseDocuments.vue?vue&type=template&id=80a74630"
import script from "./LicenseDocuments.vue?vue&type=script&lang=js"
export * from "./LicenseDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80a74630')) {
      api.createRecord('80a74630', component.options)
    } else {
      api.reload('80a74630', component.options)
    }
    module.hot.accept("./LicenseDocuments.vue?vue&type=template&id=80a74630", function () {
      api.rerender('80a74630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/management/components/specialist-tab/components/LicenseDocuments.vue"
export default component.exports